import axios from 'axios';
import {
  AiAdminConversationSummary,
  AiConversation,
} from '@shared/models/ai-chat.model';

type ListResponse = {
  conversations: AiAdminConversationSummary[];
  limit: number;
  /** Echo of which user's history the server returned — drives the dropdown's active option. */
  userId: string;
};

export type AdminUserOption = {
  userId: string;
  userName: string | null;
  email: string | null;
};

type UsersResponse = {
  admins: AdminUserOption[];
};

/** Full conversation + resolved user name (server-side lookup, may fail softly). */
export type AdminAiConversation = AiConversation & {
  userName: string | null;
};

export const adminAiChatApi = {
  list: (userId?: string) =>
    axios
      .get<ListResponse>('/admin/ai-chat', {
        params: userId ? { userId } : undefined,
      })
      .then((r) => r.data),

  listUsers: () =>
    axios.get<UsersResponse>('/admin/ai-chat/users').then((r) => r.data),

  get: (id: string) =>
    axios.get<AdminAiConversation>(`/admin/ai-chat/${id}`).then((r) => r.data),
};
